module.exports = __webpack_public_path__ + "static/media/panda.14c98419.jpg";